import Button from '@mui/material/Button';
import { ReactNode } from 'react';
import { useToggleButton } from './ToggleButtonGroup';

const style = {
  padding: '5px',
  '&.MuiButton-root': {
    fontWeight: '700',
    color: 'white',
    height: '30px',
  },
  '&.MuiButton-contained': {
    backgroundColor: '#0d3c61',
  },
};

export const ToggleButton = ({
  value,
  children,
  disabled,
  ...rest
}: {
  value: string;
  disabled?: boolean;
  children: ReactNode;
}) => {
  const { currentValue, setValue } = useToggleButton();

  return (
    <Button
      size="small"
      sx={{ ...style }}
      variant={value === currentValue ? 'contained' : 'text'}
      onClick={() => setValue(value)}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
};
